'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { toSnakeCase } from 'DesignData/lib/text';
import Small from 'UIComponents/elements/Small';
import { getSelectedField } from 'DesignData/selectors/customWidgetEditorOptions';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import NameLabel from 'DesignEditorsUI/components/shared/inputs/NameLabel';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.${key}`;

function mapStateToProps(state, props) {
  const {
    isNew
  } = getSelectedField(state, props);
  return {
    isNew
  };
}

class FieldLabel extends Component {
  constructor(props) {
    super(props);
    this.onLabelChange = this.onLabelChange.bind(this);
  }

  onLabelChange(label) {
    const {
      isNew,
      editField
    } = this.props;
    const changes = {
      label
    };

    if (isNew && label) {
      changes.name = toSnakeCase(label);
    }

    editField(changes);
  }

  renderTypeLabel() {
    return /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: this.props.field.getDefaultLabel()
    });
  }

  render() {
    const {
      field,
      isNew,
      isReadOnly
    } = this.props;
    return /*#__PURE__*/_jsx(NameLabel, {
      allowBlank: false,
      focus: isNew,
      onChange: this.onLabelChange,
      placeholder: I18n.text(i18nKey('labelPlaceholder')),
      readOnly: isReadOnly,
      typeLabel: this.renderTypeLabel(),
      value: field.label
    });
  }

}

FieldLabel.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  isReadOnly: PropTypes.bool,
  // @connect
  isNew: PropTypes.bool
};
FieldLabel.defaultProps = {
  isNew: false,
  isReadOnly: false
};
export default connect(mapStateToProps, {})(FieldLabel);